const defaultPage = 1;
const defaultSize = 10;

export default (value) => {
  if (value) {
    return `?page=${value}&size=${defaultSize}`;
  }
  return `?page=${defaultPage}&size=${defaultSize}`;
};
